<dx-validation-group>
    <div class="gpd-inner-page" style="height: 100% ; padding: 0px !important;">
        <div class="article-header-container">
           <app-gpd-button i18n-text="@@back" icon="arrow-left" text="BACK" type="text"
    [routerLink]="getBackLink()">
</app-gpd-button>

            <div class="wiki-button-container">
                <dx-button *ngIf=" article.title !== '' " class="gt-button gt-button-level-1" icon="clear"
                    (onClick)="deletePopupShow()" i18n-text="@@delete" text="Delete"></dx-button>
                <dx-button *ngIf="article.title !== ''" class="gt-button gt-button-level-1" icon="save"
                    (onClick)="$event.validationGroup.validate().isValid && saveArticle()" i18n-text="@@save"
                    text="Save"></dx-button>
            </div>
        </div>
        <dx-scroll-view class="gt-scrollable-content" id="scroll" itemOrientation="vertical" showScrollbar="always">
            <!-- <div #wikieditscrollableDiv class="gt-scrollable-content"> -->

            <div class="gpd-container paragraph-card " [style.overflow]="'unset'">
                <div class="paragraph-number" i18n="@@title">Title: </div>
                <dx-text-box class="text-box-article-title" style="background-color:white;"
                    i18n-placeholder="@@enterWikiArticleTitle" placeholder="Enter a Wiki Article title..."
                    valueChangeEvent="keyup" [(value)]="article.title" [maxLength]="100">
                    <dx-validator>
                        <dxi-validation-rule type="required"
                            message="Please enter a title for the article."></dxi-validation-rule>
                        <dxi-validation-rule type="pattern" [message]="titleForbiddenMessage"
                            [pattern]="forbiddenPattern"></dxi-validation-rule>
                    </dx-validator>
                </dx-text-box>
            </div>
            <dx-sortable class="sortable-cards-paragraph" group="paragraphGroup" [allowReordering]="true"
                [allowDropInsideItem]="false" [dropFeedbackMode]="'indicate'" [moveItemOnDrop]="true"
                (onReorder)="onParagraphReorder($event)" handle=".paragraph-handle" [autoScroll]="true"
                [scrollSensitivity]="60">
                <ng-container *ngFor="let paragraph of article.paragraphs; index as i;"
                    [ngTemplateOutlet]="paragraphTemplate"
                    [ngTemplateOutletContext]="{paragraph: paragraph, index: i }" />

            </dx-sortable>
            <div class="wiki-button-center">
                <app-gpd-button i18n-text="@@addParagraph" icon="add" text="Add Paragraph"
                    (onClick)="createParagraph()">
                </app-gpd-button>
            </div>
            <!-- </div> -->
        </dx-scroll-view>
    </div>
</dx-validation-group>

<dx-popup [resizeEnabled]="true" [dragEnabled]="true" [visible]="newBlockPopupVisible" width="auto" height="auto"
    (onHiding)="newBlockPopupVisible = false">
    <div *ngFor="let option of blockOptions" class="gt-felx-dir-col">
        <dx-button class="gt-button gt-blk-txt add-site-icon block-option-button text-left" [text]="option.text"
            [icon]="option.icon" width="250px" (onClick)="option.onClick()">
        </dx-button>
    </div>
</dx-popup>

<!-- Paragraph -->
<ng-template #paragraphTemplate let-paragraph="paragraph" let-index="index">
    <div class="gpd-container paragraph-card" style="margin: 0px !important;">

        <div class="paragraph-button-container">
            <i class="dx-icon dx-icon-dragvertical paragraph-handle"></i>
            <!-- <div class="paragraph-header">
                <div class="hide-controls">
                    <div *ngIf="paragraph.open!==true" class="dx-icon dx-icon-chevronnext expandable-icon"
                        (click)="paragraph.open = true">
                    </div>
                    <div *ngIf="paragraph.open===true" class="dx-icon dx-icon-chevrondown expandable-icon"
                        (click)="paragraph.open = false">
                    </div>
                </div>
                <div class="paragraph-number">Paragraph {{index + 1}}</div>
            </div> -->

            <app-gpd-button i18n-text="@@Delete" icon="delete" text="Delete"
                type="danger" (onClick)="deleteParagraph(paragraph.id)">
            </app-gpd-button>
        </div>
        <dx-sortable class="sortable-cards" group="cardsGroup" [data]="paragraph" (onReorder)="onBlockReorder($event)"
            (onAdd)="onBlockDrop($event)" [dropFeedbackMode]="'indicate'" [data]="paragraph" handle=".block-icon"
            [allowReordering]="true" [allowDropInsideItem]="false" [moveItemOnDrop]="true"
            (ondragstart)="disableEdit = true" (onDragEnd)="disableEdit = false">
            <ng-container [ngTemplateOutlet]="blockTemplate"
                [ngTemplateOutletContext]="{ block: block, paragraph: paragraph }"
                *ngFor="let block of paragraph.blocks">
            </ng-container>
        </dx-sortable>

        <div class="wiki-button-container">
            <app-gpd-button i18n-text="@@addSection" icon="add" text="Add Section"
                type="text" (onClick)="showNewParagraphPopup(paragraph)">
            </app-gpd-button>
        </div>
    </div>
</ng-template>

<!-- Block -->
<ng-template #blockTemplate let-block="block" let-paragraph="paragraph">
    <div class="card block-card" [class.editable]="block != currentBlock">
        <div class="article-button-container">
            <dx-button *ngIf="block != currentBlock" class="gt-button gt-button-level-2" i18n-text="@@edit" icon="edit"
                text="edit" (onClick)="editBlock(block)">
            </dx-button>

            <dx-button *ngIf="block != currentBlock" icon="clear" i18n-text="@@delete" text="Delete"
                class="gt-button gt-button-level-2" (onClick)="deleteBlock(paragraph.id, block.id)">
            </dx-button>

        </div>
        <div class="gt-flex-dir-row">
            <i class="dx-icon dx-icon-dragvertical block-icon"></i>
            <div class="card-content" *ngIf="block != currentBlock" [innerHTML]="block.content | safeHTML">
            </div>
            <div *ngIf="block == currentBlock" class="card-content">
                <div *ngIf="block.type == 'text'">
                    <ng-container *ngTemplateOutlet="htmlEditorTemplate; context: { data: block }">
                    </ng-container>
                </div>
                <div *ngIf="block.type == 'image'">
                    <ng-container *ngTemplateOutlet="fileUploadTemplate; context: { data: block, filetype: 'image' }">
                    </ng-container>
                </div>
                <div *ngIf="block.type == 'pdf'">
                    <ng-container *ngTemplateOutlet="fileUploadTemplate; context: { data: block, filetype: 'pdf' }">
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<!-- Text Block -->
<ng-template #htmlEditorTemplate let-data="data">
    <dx-html-editor [(value)]="data.content" height="400px" (onContentReady)="onEditorInitialized($event)">
        <dxo-toolbar [multiline]="true">
            <dxi-item name="undo"></dxi-item>
            <dxi-item name="redo"></dxi-item>
            <dxi-item name="separator"></dxi-item>
            <dxi-item name="size" [acceptedValues]="['8pt', '10pt', '12pt', '14pt', '18pt', '24pt', '36pt']"
                [options]="{ inputAttr: { 'aria-label': 'Font size' } }"></dxi-item>
            <dxi-item name="font" [acceptedValues]="[
                    'Arial',
                    'Courier New',
                    'Georgia',
                    'Impact',
                    'Lucida Console',
                    'Tahoma',
                    'Times New Roman',
                    'Verdana'
                  ]" [options]="{ inputAttr: { 'aria-label': 'Font family' } }"></dxi-item>
            <dxi-item name="separator"></dxi-item>
            <dxi-item name="bold"></dxi-item>
            <dxi-item name="italic"></dxi-item>
            <dxi-item name="strike"></dxi-item>
            <dxi-item name="underline"></dxi-item>
            <dxi-item name="separator"></dxi-item>
            <dxi-item name="alignLeft"></dxi-item>
            <dxi-item name="alignCenter"></dxi-item>
            <dxi-item name="alignRight"></dxi-item>
            <dxi-item name="alignJustify"></dxi-item>
            <dxi-item name="separator"></dxi-item>
            <dxi-item name="orderedList"></dxi-item>
            <dxi-item name="bulletList"></dxi-item>
            <dxi-item name="separator"></dxi-item>
            <dxi-item name="header" [acceptedValues]="[false, 1, 2, 3, 4, 5]"
                [options]="{ inputAttr: { 'aria-label': 'Header' } }"></dxi-item>
            <dxi-item name="separator"></dxi-item>
            <dxi-item name="color"></dxi-item>
            <dxi-item name="background"></dxi-item>
            <dxi-item name="separator"></dxi-item>
            <dxi-item name="link"></dxi-item>
            <dxi-item name="separator"></dxi-item>
            <dxi-item name="clear"></dxi-item>
            <dxi-item name="codeBlock"></dxi-item>
            <dxi-item name="blockquote"></dxi-item>
            <dxi-item name="separator"></dxi-item>
            <dxi-item name="insertTable"></dxi-item>
            <dxi-item name="deleteTable"></dxi-item>
            <dxi-item name="insertRowAbove"></dxi-item>
            <dxi-item name="insertRowBelow"></dxi-item>
            <dxi-item name="deleteRow"></dxi-item>
            <dxi-item name="insertColumnLeft"></dxi-item>
            <dxi-item name="insertColumnRight"></dxi-item>
            <dxi-item name="deleteColumn"></dxi-item>
        </dxo-toolbar>
    </dx-html-editor>
</ng-template>

<!-- File -->
<ng-template #fileUploadTemplate let-data="data" let-filetype="filetype">

    <div *ngIf="currentFile == null || currentFile.file == null" (drop)="onDrop($event, data, filetype)"
        (dragover)="onDragOver($event)" (click)="triggerFileInput($event)" [style.height.px]="data.contentHeight"
        [style.width.px]="data.contentWidth"
        style="border: 2px dashed #ccc; padding: 20px; text-align: center; cursor: pointer; position: relative;">
        <p i18n="@@drop"> Drop {{filetype}} here or click to upload</p>
        <input #fileInput type="file"
            [accept]="filetype == 'image' ? 'image/png, image/gif, image/jpeg' : 'application/pdf'"
            style="display: none;" (change)="onFileChanged($event.target.files[0], data)">
    </div>
</ng-template>

<app-delete-popup [visible]="deletePopupVisible" [message]="deletePopupMessage" (onAbort)="deletePopupVisible = false"
    (onConfirm)="deleteArticle()"></app-delete-popup>

<dx-toast [(visible)]="toastVisible" i18n-message message="Saved successfully"></dx-toast>

<dx-toast [visible]="toastTwoVisible" [type]="type" message="{{message}}" position="bottom center" width="fit-content">
</dx-toast>

<!-- <p >TEST</p> -->